import React from 'react';
import LibraryHero, { type LibraryHeroStat } from '../../../components/library/LibraryHero';

export type WarehouseHeroStat = LibraryHeroStat;

type WarehouseHeroProps = {
  stats: ReadonlyArray<WarehouseHeroStat>;
  actions: React.ReactNode;
  isPhone: boolean;
  statsLabel: string;
};

/** The Warehouse library hero: Events-style headline, actions and flat stat tiles (Stats toggle on phones). */
export default function WarehouseHero({ stats, actions, isPhone, statsLabel }: WarehouseHeroProps) {
  return (
    <LibraryHero
      title="Warehouse"
      body={isPhone
        ? 'Transfers, purchase orders and subrentals.'
        : 'Transfers, purchase orders and subrentals for your sites. Every row opens its record page.'}
      stats={stats}
      actions={actions}
      statsLabel={statsLabel}
      className="warehouse-hero"
      actionsClassName="warehouse-hero__actions"
      statsClassName="warehouse-hero__stats"
    />
  );
}
